/*    
<summary>
  This functional component "AddCategoryManagement" defines the props like initial values and functions for the child form component.
  Developer: Sahil Bharti, Created Date: 06-Jan-2025
</summary>
<returns>Returns JSX</returns>
*/

import { cloneDeep } from "lodash";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useStore } from "../../../../contexts/store-provider";
import { formatMessage } from "../../../../translations/format-message";
import AddUpdateReservationSettingForm from "../forms/add-update-reservation-settings-forms";

interface IProps {
  id: number;
  onSuccess: () => void;
}

const AddReservationSetttings = (props: IProps) => {
  const { masterManagementStore } = useStore();
  const {
    inProgress,
    addUpdateReservationSettingState,
    AddReservationSettingService,
    UpdateReservationSettingService,
    GetReservationSettingByIdService,
    reservationSettingState,
    getReservationSettingDetail,
    getAllTimeOptions,
    getAllStoreOptions,
    disableAction,
    resetAddUpdateReservationSettingState
  } = masterManagementStore;

  const reservationId = props.id;

  const onSubmitForm = async (values: any) => {
    let tempValues = cloneDeep(values);

    if (reservationId && reservationId > 0) {
      UpdateReservationSettingService(reservationId, tempValues);
    } else {
      AddReservationSettingService(tempValues);
    }
  };

  useEffect(()=>{
    if(addUpdateReservationSettingState.success){
       if (reservationId && reservationId > 0) {
        toast.success(formatMessage("reservation_update_success"));
      } else {
        toast.success(formatMessage("reservation_add_success"));
      }
      resetAddUpdateReservationSettingState();
      props.onSuccess();
    }
  },[addUpdateReservationSettingState.success]);

  const onModalClosed = () => {
    
  };

  return (
    <React.Fragment>
      <AddUpdateReservationSettingForm
        initialValues={getReservationSettingDetail}
        id={reservationId}
        disableAction={disableAction}
        submitHandler={onSubmitForm}
        isLoading={inProgress}
        timeOptions={getAllTimeOptions}
        storeOptions={getAllStoreOptions}
        onModalClosed={onModalClosed}
      />
    </React.Fragment>
  );
};

export default observer(AddReservationSetttings);
